import { Table } from "react-bootstrap"
import toast from "react-hot-toast"

import { useDeleteUserMutation } from "../../../app/authApiSlice"
import { useModal } from "../../../context/ModalContext"
import TypeToConfirmButton from "../../../components/buttons/TypeToConfirmButton"
import DeleteButton from "../../../components/buttons/table/DeleteButton"

const AccountsList = ({ accounts }) => {
  const { openModal } = useModal()
  const [deleteUser, { isLoading: deleting }] = useDeleteUserMutation()

  const handleDeleteUser = async (id) => {
    try {
      await deleteUser({ id }).unwrap()

      toast.success("User deleted")
    } catch (error) {
      console.log(error)
      if (error?.data?.message === 'User is a club staff member') {
        openModal({
          title: (
            <span className="text-danger">Failed to delete user</span>
          ),
          body: (
            <>
              <p className="mb-0">This user cannot be deleted because they hold staff positions in one or more clubs.</p>
              <p className="mb-0">Please remove all staff positions before deleting this user.</p>
            </>
          )
        })
      } else toast.error("An error occurred")
    }
  }

  let tableContent

  if (accounts.length < 1) {
    tableContent = (
      <tr>
        <td colSpan={3} className="text-center">
          No incomplete accounts found
        </td>
      </tr>
    )
  } else {
    tableContent = accounts.map((account) => {
      return (
        <tr key={account.id}>
          <td>{account.id}</td>
          <td>{account.email}</td>
          <td>
            {/*--- ACTION BUTTONS ---*/}
            <div className="d-flex gap-2 p-0 m-0 justify-content-center">
              {/* Delete account button */}
              {/* Delete user button */}
              <TypeToConfirmButton
                action={() => handleDeleteUser(account.id)}
                isLoading={deleting}
                title="Delete user?"
                message="This action cannot be undone."
                buttonText="Delete"
                confirmMessage="Please type user email to confirm."
                confirmString={account.email}
              >
                <DeleteButton />
              </TypeToConfirmButton>
            </div>
          </td>
        </tr>
      )
    })
  }

  return (
    <div className="overflow-auto w-100 rounded-4 py-4 px-4 shadow-sm bg-white">
      <Table hover className="mb-0 mt-1" style={{ minWidth: "730px" }}>
        <thead>
          <tr>
            <th className="">GBM Num</th>
            <th className="">Email</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {tableContent}
        </tbody>
      </Table>
    </div>
  )
}

export default AccountsList
